$(function() {

    $.home = {};

    // timelines

    $.home.tl = {};

    // in

    // logo

	$.home.tl.in = new TimelineMax({ delay: 1 });

    $.home.tl.in.addLabel("start");
    $.home.tl.in.addLabel("annual-report", 3);
    $.home.tl.in.addLabel("logo", 3.5);

    $.home.tl.in.set("#home-container", { visibility: "visible" }, "start");
    $.home.tl.in.set("#president-container", { visibility: "visible" }, "start");

    var split_1 = new SplitText("#home-container .title-home-1", {type:"words,chars"});
    var split_2 = new SplitText("#home-container .title-home-2", {type:"words,chars"});
    var split_3 = new SplitText("#home-container .title-home-3", {type:"words,chars"});
    $.home.tl.in.staggerFrom(split_1.chars, 0.01, { opacity: 0, ease:Cubic.easeIn }, 0.1, "start");
    $.home.tl.in.staggerFrom(split_2.chars, 0.01, { opacity: 0, ease:Cubic.easeIn }, 0.1, "home+=1");
    $.home.tl.in.staggerFrom(split_3.chars, 0.01, { opacity: 0, ease:Cubic.easeIn }, 0.1, "home+=2");

    $.home.tl.in.from("#home-container .title-annual-report", 1, { opacity: 0 }, "annual-report");

    $.home.tl.in.from("#president-container .logo-circle .svg-circle ellipse", 1, { drawSVG: "50%", ease:Cubic.easeOut }, "logo");
    $.home.tl.in.from("#president-container .lu-logo-shield", 1, { opacity: 0, scaleX: 0, transformOrigin: "50% 50%", ease:Cubic.easeOut }, "logo+=0.5");
	$.home.tl.in.staggerFrom("#president-container .lu-logo-lakehead path", 1, { opacity: 0, ease:Cubic.easeIn }, 0.015, "logo+=0.5");
    $.home.tl.in.staggerFrom("#president-container .lu-logo-university path", 1, { opacity: 0, delay: 0.25, ease:Cubic.easeIn }, 0.015, "logo+=0.5");
    
    $.home.tl.in.play();

    // arrow

    $.home.tl.arrow = new TimelineMax({ delay: 7, repeat: -1, repeatDelay: 2 });

    $.home.tl.arrow.addLabel("start");

	$.home.tl.arrow.fromTo('#home-container .scroll-arrow', 0.5, { opacity: 0, y: -32 }, { opacity: 1, y: 0, ease: Power1.easeOut }, "start");
    $.home.tl.arrow.to('#home-container .scroll-arrow', 0.5, { opacity: 0, y: 32, ease: Power1.easeIn });

    $.home.tl.arrow.play();

    // menu

    if ($.windowWidth > $.menuWidth * 3) {
        $.home.tl.in.fromTo("#menu-overlay", 2, { x: $.menuWidth }, { x: 0, ease:Cubic.easeInOut }, "annual-report");
        $.home.tl.in.set("#menu-btn-container", { visibility: "visible" }, "annual-report");﻿
        $.home.tl.in.fromTo("#menu-btn-container", 2, { opacity: 0 }, { opacity: 1, delay: 1, ease:Cubic.easeInOut }, "annual-report");
    } else {
        $('#menu-btn-container').css('visibility','visible');
    }

    // out

    $.home.tl.out = new TimelineMax();

    $.home.tl.out.addLabel("start");

    $.home.tl.out.to("#home-container .title-home-1", 2, { y: '-'+ Math.round($(window).innerHeight() * 2) }, "start");
    $.home.tl.out.to("#home-container .title-home-2", 2, { y: '-'+ Math.round($(window).innerHeight() * 1.5) }, "start");
    $.home.tl.out.to("#home-container .title-home-3", 2, { y: '-'+ Math.round($(window).innerHeight() * 1) }, "start");
    $.home.tl.out.to("#home-container .title-annual-report", 2, { y: '-'+ Math.round($(window).innerHeight() * 0.5) }, "start");

    new ScrollMagic.Scene({ triggerElement: '#home-pin', triggerHook: 'onLeave', duration: '100%' })
        .setPin('#home-background')
        // .addIndicators({name: 'home pin'})
        .addTo($.controller);

    new ScrollMagic.Scene({ triggerElement: '#home-trigger', triggerHook: 'onLeave', duration: '100%' })
		.on('start', function () {
			$.home.tl.in.seek($.home.tl.in.duration(), false);
            $.home.tl.arrow.pause(0);
		})
		.setTween($.home.tl.out)
		// .addIndicators({name: 'home out'})
        .addTo($.controller);

});